<div *ngIf="item!=null">
  <ngx-form-dropdown title="Type" [value]="item.type" displayField="value" keyField="key" (valueChange)="typeChanged($event)" [options]="contactTypes | enumKeys"></ngx-form-dropdown>
  <ngx-form-text [title]="item.type === contactTypes.General ? 'Address Name' : 'Contact Name'" [(value)]="item.title"></ngx-form-text>
  <ngx-form-text *ngIf="showAddressName()" title="Address Name" [(value)]="item.addressName"></ngx-form-text>
  <!-- <ngx-form-dropdown title="Attention to" [options]="employeeOptions" [(value)]="$any(item).attn"></ngx-form-dropdown> -->

  <div class="fields">
    <h4>Field</h4><br>
    
    <ng-container *ngFor="let type of fieldtypemap">
      <ng-container *ngIf="doShowField(type)">

        <ng-container [ngSwitch]="type.value">

          <ngx-doc-form-filter-select *ngSwitchCase="field.Country" [noBorder]="true" [title]="type.title" [value]="getFieldValue(type.value)" (valueChange)="setFieldValue(type.value, $event)" [options]="countryOptions"></ngx-doc-form-filter-select>
          <ngx-doc-form-filter-select *ngSwitchCase="field.IncotermsCountry" [noBorder]="true" [title]="type.title" [value]="getFieldValue(type.value)" (valueChange)="setFieldValue(type.value, $event)" [options]="countryOptions"></ngx-doc-form-filter-select>
  
          <!-- <div *ngSwitchCase="field.PaymentConditions"> -->
            <!-- <ngx-doc-form-filter-select *ngSwitchCase="field.PaymentConditions" [noBorder]="true" title="Select terms of payment" (valueChange)="storeValueChanged(type.value, $event)" [options]="data.termsOfPaymentOptions"></ngx-doc-form-filter-select> -->
            <!-- <ngx-form-text [title]="type.title" [multiline]="1" [value]="getFieldValue(type.value)" (valueChange)="setFieldValue(type.value, $event)"></ngx-form-text> -->
          <!-- </div> -->
  
          <!-- <div *ngSwitchCase="field.PaymentText"> -->
            <!-- <ngx-doc-form-filter-select *ngSwitchCase="field.PaymentText" [noBorder]="true" title="Select payment text" (valueChange)="storeValueChanged(type.value, $event)" [options]="data.paymentTextOptions"></ngx-doc-form-filter-select> -->
            <!-- <ngx-form-text [title]="type.title" [multiline]="1" [value]="getFieldValue(type.value)" (valueChange)="setFieldValue(type.value, $event)"></ngx-form-text> -->
          <!-- </div> -->

          <ngx-doc-form-filter-select *ngSwitchCase="field.PaymentConditions" [noBorder]="true" title="Select terms of payment"  [value]="getFieldValue(type.value)" (valueChange)="setFieldValue(type.value, $event)" [options]="data.termsOfPaymentOptions"></ngx-doc-form-filter-select>
  
          <ngx-doc-form-filter-select *ngSwitchCase="field.PaymentText" [noBorder]="true" title="Select payment text"  [value]="getFieldValue(type.value)" (valueChange)="setFieldValue(type.value, $event)" [options]="data.paymentTextOptions"></ngx-doc-form-filter-select>

          <ngx-form-dropdown *ngSwitchCase="field.Incoterms" [value]="getFieldValue(type.value)" (valueChange)="setFieldValue(type.value, $event)" [options]="incotermsOptions"></ngx-form-dropdown>

          <ngx-form-text *ngSwitchCase="field.Info" [title]="type.title" [multiline]="1" [value]="getFieldValue(type.value)" (valueChange)="setFieldValue(type.value, $event)"></ngx-form-text>

          <ngx-form-text *ngSwitchCase="field.Instructions" [title]="type.title" [multiline]="1" [value]="getFieldValue(type.value)" (valueChange)="setFieldValue(type.value, $event)"></ngx-form-text>

          <!-- <ngx-form-text *ngSwitchCase="field.Address2" [title]="type.title" [multiline]="1" [value]="getFieldValue(type.value)" (valueChange)="setFieldValue(type.value, $event)"></ngx-form-text> -->

          <ng-container *ngIf="[8,9,10,11,12].includes(+item.type)"><!-- invoiceSendTo, DNsendTo, TCsendTo, OCSendTo -->
            <ngx-form-dropdown *ngSwitchCase="field.Email" title=" ↡ Add Email" [options]="emailOptions" (valueChange)="setFieldValue(type.value, getFieldValue(type.value) + '\n' + $event)"></ngx-form-dropdown>
            <ngx-form-text *ngSwitchCase="field.Email" [title]="type.title" [multiline]="1" [value]="getFieldValue(type.value)" (valueChange)="setFieldValue(type.value, $event)"></ngx-form-text>
            <ngx-form-dropdown *ngSwitchCase="field.SendingDate" title="Date of Sending" [value]="getFieldValue(type.value)" (valueChange)="setFieldValue(type.value, $event)" [options]="docConfig.reportDateFieldOptions"></ngx-form-dropdown>
            <ngx-form-text *ngSwitchCase="field.SendingDays" title=" ↟ + Number of Days" [value]="getFieldValue(type.value)" (valueChange)="setFieldValue(type.value, $event)"></ngx-form-text>
          </ng-container>

          <div *ngSwitchCase="field.SendMode" class="pt-4">
            <nb-radio-group [ngModel]="getFieldValue(type.value)" (ngModelChange)="setFieldValue(type.value, $event)">
              <nb-radio [value]="1">Send via Email</nb-radio>
              <nb-radio [value]="2">Send Hardcopy</nb-radio>
              <nb-radio [value]="3">Both</nb-radio>
            </nb-radio-group>
          </div>


          <ngx-form-text *ngSwitchDefault [title]="type.title" [value]="getFieldValue(type.value)" (valueChange)="setFieldValue(type.value, $event)"></ngx-form-text>


        </ng-container>

        <!-- <ngx-form-text *ngIf="!isCountry(field.value) && !isIncoterms(field.value) && !isTerms(field.value) && !isTermsText(field.value)" [title]="field.title" [value]="getFieldValue(field.value)" (valueChange)="setFieldValue(field.value, $event)"></ngx-form-text>

        <ngx-doc-form-filter-select *ngIf="isCountry(field.value)" [noBorder]="true" [title]="field.title" [value]="getFieldValue(field.value)" (valueChange)="setFieldValue(field.value, $event)" [options]="countryOptions"></ngx-doc-form-filter-select>

        <div *ngIf="isTerms(field.value)">
          <ngx-doc-form-filter-select [noBorder]="true" title="Select terms of payment" (valueChange)="storeValueChanged(field.value, $event)" [options]="data.termsOfPaymentOptions"></ngx-doc-form-filter-select>
          <ngx-form-text [title]="field.title" [multiline]="1" [value]="getFieldValue(field.value)" (valueChange)="setFieldValue(field.value, $event)"></ngx-form-text>
        </div>

        <div *ngIf="isTermsText(field.value)">
          <ngx-doc-form-filter-select [noBorder]="true" title="Select payment text" (valueChange)="storeValueChanged(field.value, $event)" [options]="data.paymentTextOptions"></ngx-doc-form-filter-select>
          <ngx-form-text [title]="field.title" [multiline]="1" [value]="getFieldValue(field.value)" (valueChange)="setFieldValue(field.value, $event)"></ngx-form-text>
        </div>

        <ngx-form-dropdown *ngIf="isIncoterms(field.value)" [title]="field.title" [value]="getFieldValue(field.value)" (valueChange)="setFieldValue(field.value, $event)" [options]="incotermsOptions"></ngx-form-dropdown> -->

      </ng-container>
    </ng-container>
  </div>

  <!-- <ngx-form-list
    title="Fields"
    [columns]="fieldColumns"
    [(value)]="item.fields"
    [canDelete]="true"
    (editConfirm)="validate($event)">
  </ngx-form-list> -->
</div>
